const DEFAULT_RAVI_FRONT_BASE_URL = 'https://ravi-front-ravi.p24cloud.ir';

export const RAVI_MY_REVIEWS_PATH = '/ravi/v2/my-reviews';

/** Only numeric ids may be forwarded to ravi-front as ?feedback=. */
export const parseFeedbackId = (value: unknown): string | undefined => {
  const raw = Array.isArray(value) ? value[0] : value;
  const trimmed = String(raw ?? '').trim();
  return /^\d{1,12}$/.test(trimmed) ? trimmed : undefined;
};

export const buildRaviMyReviewsUrl = (token?: string, feedbackId?: string): string => {
  const baseUrl = (process.env.NEXT_PUBLIC_RAVI_FRONT_BASE_URL || DEFAULT_RAVI_FRONT_BASE_URL).replace(
    /\/$/,
    '',
  );
  const url = new URL(RAVI_MY_REVIEWS_PATH, `${baseUrl}/`);
  const trimmed = String(token ?? '').trim();
  if (trimmed) {
    url.searchParams.set('token', trimmed);
  }
  const focusId = parseFeedbackId(feedbackId);
  if (focusId) {
    url.searchParams.set('feedback', focusId);
  }
  return url.toString();
};
